import { get } from './'

export function getDepositRates () {
  return get('/deposit_setting')
}



// WEBPACK FOOTER //
// ./src/api/cart.js